import { module as BaseModule } from 'modujs'
import { language } from '../utils/dom'
// import { load } from 'recaptcha-v3'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.submit = this.el.querySelector('[data-form-submit]')
    this.email = this.el.querySelector('input[type="email"]')
    this.checkbox = this.el.querySelector('input[type="checkbox"]')
    this.antispam = this.el.querySelector('[data-form-antispam]')

    this.isSending = false
    this.isSent = false
    this.isSpam = false

    this.initEventListeners()
  }

  initEventListeners() {
    this.email.addEventListener('change', () => {
      this.checkEmail()
    })

    this.el.addEventListener('submit', async (e) => {
      e.preventDefault()
      this.checkSpam()
      if (this.isSending || this.isSent || this.isSpam) return
      this.send()
    })
  }

  checkSpam() {
    if (this.antispam.value !== '') this.isSpam = true
  }

  checkEmail() {
    this.email.value.trim() === ''
      ? this.email.classList.add('--invalid')
      : this.email.classList.remove('--invalid')
  }

  success(message) {
    this.submit.innerHTML = language('Subscribed!', 'Souscrit!')
    this.email.value = ''
    this.email.classList.remove('--invalid')
    this.email.placeholder = message
  }

  fail(message) {
    this.submit.innerHTML = language('Subscribe', 'Souscrire')
    this.email.value = ''
    this.email.classList.add('--invalid')
    this.email.placeholder = message
  }

  async send() {
    this.isSending = true

    this.submit.innerHTML = language('Sending...', 'Envoi en cours...')

    this.nonce = ajaxObject.nonce

    const data = new FormData()
    data.append('action', 'subscribe')
    data.append('email', this.email.value)
    data.append('news', this.checkbox.checked)
    data.append('nonce', this.nonce)

    const self = this

    const xhr = new XMLHttpRequest()
    xhr.open('POST', ajaxObject.ajaxurl, true)

    xhr.onload = async function () {
      // console.log(this)

      const response = await JSON.parse(this.response)
      // console.log(response)

      const en = response.data.en
      const fr = response.data.fr

      const noticeMessage = language(en, fr)

      if (this.status >= 200 && this.status < 400) {
        self.success(noticeMessage)
        self.isSent = true
      } else {
        self.fail(noticeMessage)
        self.isSending = false
      }
    }
    xhr.send(data)
  }
}
